module.exports = __webpack_public_path__ + "static/img/Acer_G9_791.eb0a83ef.png";